<template>

    <div v-if="controlModel">

        <modal :showModal="showModal" :hideModal="closeModal">

            <h5 slot="header">Détails du contrôle : {{ controlModel.controlId }}</h5>

            <span slot="body" class="w-100">

                <div class="row">
                    <div class="col-4"><b>Motif : </b></div>
                    <div class="col-8">{{ controlModel.reason }}</div>
                </div>

                <hr>

                <div class="row">
                    <div class="col-4"><b>Date : </b></div>
                    <div class="col-8">{{ controlModel.date_time_control }}</div>
                </div>

                <hr>

                <div class="row">
                    <div class="col-4"><b>Agent : </b></div>
                    <div class="col-8">{{ controlModel.officer }}</div>
                </div>

                <hr>

                <div class="row">
                    <div class="col-4"><b>Type de tenue : </b></div>
                    <div class="col-8">{{ controlModel.outfit === 'uniform' ? 'Uniforme' : 'Civil'}}</div>
                </div>

                <hr>

                <div class="row">
                    <div class="col-4"><b>Type de contrôle : </b></div>
                    <div class="col-8">{{ controlModel.controlType === 'moving' ? 'Embarqué' : 'Sol'}}</div>
                </div>

                <hr>

                <div class="row">
                    <div class="col-4"><b>Ligne : </b></div>
                    <div class="col-8">{{ controlModel.line }}</div>
                </div>

                <hr>

                <div class="row">
                    <div class="col-4"><b>Véhicule : </b></div>
                    <div class="col-8">{{ controlModel.vehicle }}</div>
                </div>

                <hr>

                <div class="row">
                    <div class="col-4"><b>Station de départ : </b></div>
                    <div class="col-8">{{ controlModel.stationStart }}</div>
                </div>

                <hr>

                <div class="row">
                    <div class="col-4"><b>Station d'arrivée : </b></div>
                    <div class="col-8">{{ controlModel.stationEnd }}</div>
                </div>

            </span>

            <span slot="footer">
                <button class="btn btn-danger" @click="closeModal">Fermer</button>
            </span>

        </modal>

    </div>

</template>

<script>

    import axios from "axios";
    import Modal from './Modal';

    export default {
        name: 'controlDetailsModal',
        components: {Modal},
        props: {
            showModal: Boolean,
            closeModal: Function,
            controlId: {
                type: Number,
                required: true
            }
        },
        data() {
            return {
                controlModel: null,
            }
        },
        created() {
            this.getControl(this.controlId);
        },
        watch: {
            controlId: function (newVal, oldVal) {
                this.getControl(this.controlId);
            }
        },
        methods: {
            getControl(controlId) {
                axios.get('/api/controls/' + controlId)
                    .then(result => {
                        this.controlModel = result.data;
                    });
            },
        }
    }

</script>



// WEBPACK FOOTER //
// resources/js/components/layout/ControlDetailsModal.vue